import React from 'react'
import Link from '../Link/index'
import Picture, { IMAGE_TYPE_WEBP, IMAGE_LOADING_LAZY } from '../Picture/index'

/**
 * @param {Object} props - The props
 * @param {Map} props.metaItem - The meta item
 * @param {Boolean} props.isInline - If meta should be displayed inline
 * @param {Map} props.staticText - The static text
 * @returns {JSX.Element} DetailPageV3MetaItem
 */

const DetailPageV3MetaItem = (props) => {
  const {
    metaItem,
    isInline = false,
    staticText,
  } = props

  const metaItemClassName = [
    'detail-page-v3__meta-item',
    isInline ? 'detail-page-v3__meta-item--inline' : null,
  ].filter((cls) => !!cls).join(' ')

  const metaItemText = metaItem.get('items').map((item, index) => {
    const separator = index === metaItem.get('items').size - 1 ? '' : ', '
    if (item.get('path')) {
      return (
        <span key={item.get('title')}>
          <Link to={item.get('path')}>
            {item.get('title')}
          </Link>{separator}
        </span>
      )
    }
    return (
      <span key={item.get('title')}>
        <span>
          {item.get('title')}
        </span>{separator}
      </span>
    )
  })

  return (
    <div className={metaItemClassName}>
      {isInline
        ? <div className="detail-page-v3__meta-item-data">
          <span className="detail-page-v3__meta-item-label">
            {staticText.get(metaItem.get('textKey'))}
          </span>
          {': '}
          <span className="detail-page-v3__meta-item-text">
            {metaItemText}
          </span>
        </div>
        : <>
          {metaItem.get('imageUrls') && (
            <div className="detail-page-v3__meta-item-image">
              <Picture
                fallbackSrc={metaItem.getIn(['imageUrls', 'fallbackImageUrl'])}
                width={'56'}
                height={'56'}
                alt={metaItem.getIn(['items', 0, 'title'])}
                loading={IMAGE_LOADING_LAZY}
                sources={[
                  {
                    type: IMAGE_TYPE_WEBP,
                    srcSet: metaItem.getIn(['imageUrls', 'imageUrl']),
                  },
                ]}
              />
            </div>
          )}
          <div className="detail-page-v3__meta-item-data">
            <p className="detail-page-v3__meta-item-label">
              {staticText.get(metaItem.get('textKey'))}
            </p>
            <p className="detail-page-v3__meta-item-text">
              {metaItemText}
            </p>
          </div>
        </>
      }
    </div>
  )
}

export default DetailPageV3MetaItem
